var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"d-flex gap-1",domProps:{"innerHTML":_vm._s(_vm.showAppliedFilters())}}),_c('v-divider',{staticClass:"mx-5",attrs:{"vertical":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }